import { ESignupChannel } from "features/common/types";
import { ILookupInviteResponse } from "../types";

export const mockLookupInviteResponse: ILookupInviteResponse = {
  result: {
    email: "john.doe@dot.com",
    communityAccountId: 1,
    userExists: false,
    organisationExists: false,
    productSalesTypeIds: [123],
    signupSessionId: "123-345-678",
    brand: "cl",
    productSiloId: 1,
    productSiloName: "Constructionline",
    channel: ESignupChannel.Public,
    agentEmail: null,
    orgBypassInfo: null
  },
  isSuccess: true,
  message: "",
  validationIssues: null
};
